(() => {
  const storageKey = 'gc_product_entry_context';
  const maxAgeMs = 5 * 60 * 1000;

  const normalizeDevice = (value) => {
    const device = String(value || '').trim().toLowerCase();
    return device === 'iphone' || device === 'samsung' ? device : '';
  };

  const normalizePath = (value) => {
    const path = String(value || '').trim();
    return path.startsWith('/products/') ? path : '';
  };

  const clear = () => {
    try {
      window.sessionStorage.removeItem(storageKey);
    } catch (error) {
      // Navigation remains functional when sessionStorage is unavailable.
    }
  };

  const store = (urlLike, context = {}) => {
    try {
      const url = new URL(urlLike, window.location.origin);
      const path = normalizePath(url.pathname);
      const device = normalizeDevice(context.device);
      const model = String(context.model || '').trim();
      const finish = String(context.finish || '').trim();

      if (!path || (!device && !model && !finish)) return;

      window.sessionStorage.setItem(storageKey, JSON.stringify({
        path,
        device,
        model,
        finish,
        timestamp: Date.now()
      }));
    } catch (error) {
      // The clean href still provides the normal product-page fallback.
    }
  };

  const consume = (pathname) => {
    try {
      const raw = window.sessionStorage.getItem(storageKey);
      window.sessionStorage.removeItem(storageKey);
      if (!raw) return null;

      const context = JSON.parse(raw);
      const path = normalizePath(context?.path);
      const timestamp = Number(context?.timestamp);
      if (!path || path !== pathname || !Number.isFinite(timestamp) || Date.now() - timestamp > maxAgeMs) {
        return null;
      }

      const device = normalizeDevice(context.device);
      const model = String(context.model || '').trim();
      const finish = String(context.finish || '').trim();
      return device || model || finish ? { device, model, finish } : null;
    } catch (error) {
      clear();
      return null;
    }
  };

  const storeForLink = (link) => {
    if (!(link instanceof HTMLAnchorElement)) return;
    store(link.href, {
      device: link.dataset.gcDevice,
      model: link.dataset.gcModel
    });
  };

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element
      ? event.target.closest('a[data-gc-product-entry]')
      : null;
    if (link) storeForLink(link);
  }, true);

  document.addEventListener('auxclick', (event) => {
    if (event.button !== 1) return;
    const link = event.target instanceof Element
      ? event.target.closest('a[data-gc-product-entry]')
      : null;
    if (link) storeForLink(link);
  }, true);

  window.GoCraftlyProductEntryContext = { consume, store, clear };
})();
